module.exports = __webpack_public_path__ + "img/1.a7a26863.png";